import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FB_BRAND = {
  name: "FB Environnement",
  tagline: "Espace commercial",
  hex: "#9DCB2E", // vert pistache principal
  hexHover: "#86b323",
  hexDark: "#1F6B2E", // vert sapin pour accent dark
  accent: "#1F6B2E",
  accentText: "#0f3a18",
  website: "https://www.fbenvironnement.fr",
  logo: "/images/logo-fb.png",
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUS_LABELS = {
  prospect: "Prospect",
  negociation: "En négociation",
  signe: "Signé",
  refuse: "Refusé",
};

export const STATUS_COLORS = {
  prospect: "bg-sky-100 text-sky-700 border-sky-200",
  negociation: "bg-amber-100 text-amber-700 border-amber-200",
  signe: "bg-emerald-100 text-emerald-700 border-emerald-200",
  refuse: "bg-rose-100 text-rose-700 border-rose-200",
};

export const OUTCOME_LABELS = {
  interesse: "Intéressé",
  a_relancer: "À relancer",
  vente: "Vente conclue",
  pas_interesse: "Pas intéressé",
};

export const OUTCOME_COLORS = {
  interesse: "bg-sky-100 text-sky-700",
  a_relancer: "bg-amber-100 text-amber-700",
  vente: "bg-emerald-100 text-emerald-700",
  pas_interesse: "bg-stone-200 text-stone-700",
};

export const MATERIAL_COLORS = {
  "Gravats": "bg-stone-600 text-white",
  "Plâtre & placo": "bg-rose-300 text-rose-950",
  "Mélange bitumineux": "bg-neutral-800 text-white",
  "Déchets verts": "bg-green-600 text-white",
  "Souches & troncs": "bg-amber-900 text-white",
  "Bois": "bg-amber-700 text-white",
  "DIB": "bg-indigo-500 text-white",
  "Archives": "bg-red-600 text-white",
  "Pneus VL": "bg-zinc-700 text-white",
  "Pneus PL": "bg-zinc-900 text-white",
};

export const MATERIAL_SLUGS = {
  "Gravats": "gravats",
  "Plâtre & placo": "platre",
  "Mélange bitumineux": "bitumineux",
  "Déchets verts": "verts",
  "Souches & troncs": "souches",
  "Bois": "bois",
  "DIB": "dib",
  "Archives": "archives",
  "Pneus VL": "pneus-vl",
  "Pneus PL": "pneus-pl",
};

export const MATERIALS = [
  "Gravats",
  "Plâtre & placo",
  "Mélange bitumineux",
  "Déchets verts",
  "Souches & troncs",
  "Bois",
  "DIB",
  "Archives",
  "Pneus VL",
  "Pneus PL",
];

// Tailles de bennes autorisées par matière (par défaut : toutes).
// Gravats / Mélange bitumineux : pas de 40 m³ (trop lourd).
// Souches & troncs : prix à la pièce (pas de benne, pas de tonne).
// Pneus : prix à la tonne uniquement (pas de benne).
export const BENNE_SIZES_ALL = ["3", "5", "8", "10", "12", "15", "20", "30", "40"];
export const BENNE_SIZES_BY_MATERIAL = {
  "Gravats": ["3", "5", "8", "10", "12", "15", "20", "30"],
  "Mélange bitumineux": ["3", "5", "8", "10", "12", "15", "20", "30"],
  "Souches & troncs": [],
  "Pneus VL": [],
  "Pneus PL": [],
};

// Matières facturées à la pièce/unité (le champ "per_ton" sert alors de prix unitaire)
export const UNIT_PRICED_MATERIALS = ["Souches & troncs"];
export const UNIT_LABELS = {
  "Souches & troncs": "pièce",
};
export function allowedBenneSizes(material) {
  const v = BENNE_SIZES_BY_MATERIAL[material];
  return v === undefined ? BENNE_SIZES_ALL : v;
}
